import { useState, useEffect } from 'react';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Helmet } from 'react-helmet-async';
import { Link, Link as RouterLink, useNavigate, BrowserRouter as Router, Switch, Route, NavLink } from 'react-router-dom';
import { useForm } from "react-hook-form";
import Multiselect from 'multiselect-react-dropdown';
import { toast } from "react-toastify";
// @mui  
import { styled } from '@mui/material/styles';
import { Button, Typography, Container, Box, Modal } from '@mui/material';
import config from "../../config";
import { encryptData } from '../../utils/cryptoUtils';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.bundle';
import "bootstrap-icons/font/bootstrap-icons.css";
import '../common.scss';
import * as userActions from "../../actions/userActions";
import * as leadActions from "../../actions/leadActions";
import * as incidentReporteActions from "../../actions/incidentReporteActions";

import AccessDenied from '../common/AccessDenied';

// ----------------------------------------------------------------------

const StyledContent = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  minHeight: '100vh',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  padding: theme.spacing(12, 0),
}));

// ----------------------------------------------------------------------

const leadFlagFields = new Set([
  'fast_track_test_rule',
  'is_fleet',
  'fast_track',
  'only_lead_name_policy',
  'check_age',
  'check_pincode',
  'beurau_score',
  'lead_city',
  'lead_profile'
]);

const getEnabledLeadFlags = (record) => {
  if (!record || typeof record !== 'object') return [];
  const fields = Object.entries(record);
  const markerIndex = fields.findIndex(([key]) => key === 'is_used_loan');
  if (markerIndex < 0) return [];

  return fields.slice(markerIndex + 1)
    .filter(([key, value]) => {
      const isRuleFlag = leadFlagFields.has(key) || key.startsWith('rule_');
      const isEnabled = (typeof value === 'string' || typeof value === 'number') && String(value).trim() === '1';
      return isRuleFlag && isEnabled;
    })
    .map(([key]) => ({
      key,
      label: key.replace(/^rule_/, '').replace(/_/g, ' ').replace(/\b\w/g, letter => letter.toUpperCase())
    }));
};
const LeadsPage2 = (props) => {
  const { actions, leadsData, usersData, sourceData, getUserModuleData, masterProfileData, leadStatusData } = props;
  const { register, handleSubmit, formState: { errors }, setValue } = useForm();
  const navigate = useNavigate();
  const [allLeads, setAllLeads] = useState([]);
  const [open, setOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState('');
  const [viewModalInfo, setViewModalInfo] = useState([]);
  const [showLeadDetails, setShowLeadDetails] = useState(false);
  const [openFleetModal, setOpenFleetModal] = useState(false);
  const [fleetRecordsInfo, setFleetRecordsInfo] = useState([]);

  const [selectedUsers, setSelectedUsers] = useState([]);
  const [selectedLeadSource, setSelectedLeadSource] = useState([]);
  const [getSelectedLeadStatus, setSelectedLeadStatus] = useState([]);
  const [getSelectedLeadProfile, setSelectedLeadProfile] = useState([]);
  const [allUsers, setAllUsers] = useState([]);
  const [allLeadSource, setAllLeadSource] = useState([]);


  const [viewModulePermissionStatus, setViewModulePermissionStatus] = useState(false);
  const [userHasPermission, setUserHasPermission] = useState(true);
  const [permissions, setPermissions] = useState([]);
  const [allLeadStatusData, setAllLeadStatusData] = useState([]);
  const [allMasterProfiles, setAllMasterProfiles] = useState([]);
  const [legalFormId, setLegalFormId] = useState('person');

  const [userRoleType, setUserRoleType] = useState('');
  const [loggeInUserID, setLoggeInUserID] = useState('');

  const [allLoggedinUserChild, setAllLoggedinUserChild] = useState([]);
  const [isExternalUser, setIsExternalUser] = useState(false);
  const [viewUPIModulePermissionStatus, setViewUPIModulePermissionStatus] = useState(false);
  const [isCamChecked, setIsCamChecked] = useState(false);
  const [filters, setFilters] = useState(null);
  const [states, setStates] = useState([]);

    useEffect(() => {
      fetchStates();
    }, []);

    const fetchStates = () => {
      fetch(`${config.API_BASE_URL}fetch_states_code`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then(res => res.json())
        .then(result => {
          if (result && result.success === 1) {
            setStates(result.data || []);
          } else if (Array.isArray(result)) {
            setStates(result);
          } else if (result && result.data) {
            setStates(result.data);
          }
        })
        .catch(err => {
          console.log("Error:", err);
        });
    };
  
   
  
  useEffect(() => { 
    const obj = { 'start': '0', 'length': config.MAX_RECORDS };
    const requestData = encryptData(obj);
    const roleName = localStorage.getItem('authUserRoleName');
    if (roleName !== null) {
        setUserRoleType(roleName); 
    }
    const response = actions.getUserModuleData(requestData);
    response.then((result) => {
      if (result.data.success === 1) {
        const permissionsData = result.data.data;
        const hasViewPermissions = permissionsData.find(permission => permission.module_name === 'Leads')?.view_permission;
        setPermissions(permissionsData);
        setViewModulePermissionStatus(hasViewPermissions);
        setUserHasPermission(hasViewPermissions);

        if(Object.prototype.hasOwnProperty.call(result.data, 'user_info') && Object.prototype.hasOwnProperty.call(result.data.user_info[0], 'role_type')  && result.data.user_info[0].role_type !==''){
            setUserRoleType(result.data.user_info[0].role_type);
            // alert(result.data.user_info[0].role_type);
            setLoggeInUserID(result.data.user_info[0].user_id);

            if(result.data.user_info[0].role_type.toLowerCase() === "credit head"){
              setIsCamChecked(true);
            }
           
        }

        if(Object.prototype.hasOwnProperty.call(result.data, 'user_info') && Object.prototype.hasOwnProperty.call(result.data.user_info[0], 'is_external_user')  && result.data.user_info[0].is_external_user !== '' && result.data.user_info[0].is_external_user === "1"){
          setIsExternalUser(true);
        }

        const hasViewUPIPermissions = permissionsData.find(permission => permission.module_name === 'UPI Registration')?.view_permission;
        setViewUPIModulePermissionStatus(hasViewUPIPermissions);
      }
    }).catch((error) => {
      console.error("Promise rejected -  lead list:", error);
    });
  }, [setPermissions, setUserHasPermission, setUserRoleType, setLoggeInUserID,setIsExternalUser]);

  

  const onSubmit = (data) => {

    const params = {
      'start': '0',
      'length': config.MAX_RECORDS,
      'assign_to': selectedUsers,
      'start_date': data.start_date,
      'end_date': data.end_date,
      'keyword': data.keyword,
      'fast_track_status': data.fast_track_status,
      'lead_source': selectedLeadSource,
      'lead_status': getSelectedLeadStatus,
      'lead_profile': getSelectedLeadProfile,
      "action_status" : data.action_status, 
      "state": data.state,
      "user_role_type": userRoleType,
      "debit_date1": data.debit_date1,
      "emi_amount1": data.emi_amount1,
      "is_cam_leads": isCamChecked
    };

    setCurrentPage(1);
    setPreloaderSearchStatus(true); 
    const requestData = encryptData(params);
    const response = actions.leadsData(requestData, true, true);
    response.then((result) => {
      console.log("When we Submit the Upi Registration:", result);
      if (result.data.success === 1) {
        setShowLeadDetails(true);
        const results = result.data.data.data;
        const resultArr = Object.keys(results).map((key) => results[key]);
        setAllLeads(resultArr);
      } else {
        setAllLeads([]);
      }
      setPreloaderSearchStatus(false); 
    }).catch((error) => {
      console.error("Promise rejected -  lead list:", error);
    });

  };


  useEffect(() => {
    // check user is logged-in or not
    const authToken = localStorage.getItem('authToken');
    if (authToken === null) {
      navigate('/login');
    }

    if('caches' in window){
      caches.keys().then((names) => {
              // Delete all the cache files
              names.forEach(name => {
                  caches.delete(name);
              })
          });  
      }

    const today = new Date();
    const formattedToday = today.toISOString().split('T')[0]; 
    const threeMonthsAgo = new Date();
    threeMonthsAgo.setMonth(today.getMonth() - 2);
    const formattedThreeMonthsAgo = threeMonthsAgo.toISOString().split('T')[0];  
  
    setValue('start_date', formattedThreeMonthsAgo);
    setValue('end_date', formattedToday);

    let userRoleTypeVal = userRoleType;
    let isCamCheckedVal = isCamChecked;
    const roleName = localStorage.getItem('authUserRoleName');
 
    if (roleName !== null) {
        setUserRoleType(roleName); 
        userRoleTypeVal = roleName;
        if(roleName.toLowerCase() === "credit head"){
          setIsCamChecked(true);
          isCamCheckedVal = true;
        } 
    }

    setShowLeadDetails(false);
    if (!showLeadDetails) {
      const obj = { 'start': '0', 'length': config.MAX_RECORDS, "user_role_type": userRoleTypeVal ,
        "is_cam_leads": isCamCheckedVal,'start_date' : formattedThreeMonthsAgo, 'end_date': formattedToday};
      const requestData = encryptData(obj);
      setPreloaderSearchStatus(true); 
      const response = actions.leadsData(requestData);
      response.then((result) => {
        if (result.data.success === 1) {
          setShowLeadDetails(true);
          const results = result.data.data.data;
          const resultArr = Object.keys(results).map((key) => results[key]);
          setAllLeads(resultArr);
        }
        setPreloaderSearchStatus(false);
      }).catch((error) => {
        console.error("Promise rejected -  lead list:", error);
      });
    }


    if (Array.isArray(usersData.data)) {
      const extractedData = usersData.data.map(item => {
        return { id: item.user_id, name: item.name };
      });
      const resultArr = Object.values(extractedData);
      setAllUsers(resultArr);
    }

    const objSource = { 'start': '0', 'length': config.MAX_RECORDS };
    const requestSourceData = encryptData(objSource);
    const responseSource = actions.sourceData(requestSourceData,false);
    responseSource.then((result) => {
        if (result.data.success === 1) {
            const results = result.data.data.data
            const filteredResultArr = results.filter((item) => item.status === "1");
            const sortedResultArr = filteredResultArr.sort((a, b) =>
                a.source_of_lead.localeCompare(b.source_of_lead)
            );
            const extractedData = sortedResultArr.map(item => {
              return { id: item.id, name: item.source_of_lead };
            });
            const resultArr = Object.values(extractedData);
            setAllLeadSource(resultArr);
        }
    }).catch((error) => {
    });

    const objMasterProfile = { 'start': '0', 'length': config.MAX_RECORDS };
    const requestDataMasterProfile = encryptData(objMasterProfile);
    const responseMasterProfile = actions.masterProfileData(requestDataMasterProfile, false);
    responseMasterProfile.then((result) => {
        if (result.data.success === 1) {
            const results = result.data.data.data;
            const resultArr = Object.keys(results).map((key) => results[key]);
            const filteredResultArr = resultArr.filter((item) => item.status === "1");
            const sortedResultArr = filteredResultArr.sort((a, b) =>
                a.lead_profile_name.localeCompare(b.lead_profile_name)
            );

            const extractedData = sortedResultArr.map(item => {
              return { id: item.id, name: item.lead_profile_name };
            });
            const extractedObject = Object.values(extractedData);
            setAllMasterProfiles(extractedObject);
        }
    }).catch((error) => {
        //  console.error("Promise rejected -  source data :", error); 
    });

    const objLeadStatus = { 'start': '0', 'length': config.MAX_RECORDS };
    const requestLeadStatusData = encryptData(objLeadStatus); 
    const leadStatusResponse = actions.leadStatusData(requestLeadStatusData);
    leadStatusResponse.then((result) => {
        if (result.data.success === 1) {
            setAllLeadStatusData(true);
            const results = result.data.data.data;
            const resultArr = Object.keys(results).map((key) => results[key]);
            const filteredResultArr = resultArr.filter((item) => item.status === "1");
            const sortedResultArr = filteredResultArr.sort((a, b) =>
                a.lead_status.localeCompare(b.lead_status)
            );

            const extractedData = sortedResultArr.map(item => {
              return { id: item.id, name: item.lead_status };
            });
            const extractedObject = Object.values(extractedData);
            setAllLeadStatusData(extractedObject);
        }
    }).catch((error) => {
        //  console.error("Promise rejected -  lead status data :", error); 
    });

  }, [leadsData, setAllUsers, setAllLeadSource, setAllMasterProfiles, setAllLeadStatusData]);

  useEffect(() => {
    // setAllLeadStatusData(false);
    const obj = { 'start': '0', 'length': config.MAX_RECORDS };
    const requestData = encryptData(obj);
    const response = actions.getLoggedinUserChild(requestData, false);

    response.then((result) => {
        if (result.data.success === 1) {
            const results = result.data.data.data;
            
            const extractedData = results.map(item => {
              return { id: item.user_id, name: item.name };
            });
            const resultArr = Object.values(extractedData);
            setAllLoggedinUserChild(resultArr);
        }
    }).catch((error) => {
        //  console.error("Promise rejected -  source data :", error); 
    });
}, [setAllLoggedinUserChild]);

  const handleClose = () => {
    setOpen(false);
  };

  const handleViewFleetRecords = (records) => {
    setFleetRecordsInfo(Array.isArray(records) ? records : []);
    setOpenFleetModal(true);
  };

  const handleCloseFleetModal = () => {
    setOpenFleetModal(false);
    setFleetRecordsInfo([]);
  };

  const onRowClickAction = (itemObj, btnAction) => {
    const encodedId = btoa(String(itemObj.id));
    if (btnAction === 'edit') {
      const url = `/dashboard/edit-lead-v3/${encodedId}`;
    } else {
      setViewModalInfo(itemObj);
      setOpen(true);
    }
  }

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
    setCurrentPage(1); // Reset to the first page when searching
  };

  const filteredItems = allLeads.filter(item => {
    const name = item.name?.toLowerCase() || '';
    const formattedID = item.formatetdID?.toLowerCase() || '';
    const createdByName = item.createdByName?.toLowerCase() || '';
    const statusName = item.statusName?.toLowerCase() || '';
    const mobile = item.mobile?.toLowerCase() || '';

    return (
      name.includes(searchQuery.toLowerCase()) ||
      formattedID.includes(searchQuery.toLowerCase()) ||
      createdByName.includes(searchQuery.toLowerCase()) ||
      statusName.includes(searchQuery.toLowerCase()) ||
      mobile.includes(searchQuery.toLowerCase())
    );
  });
  const startIndex = (currentPage - 1) * config.HUNDREAD_PER_PAGE;
  const endIndex = startIndex + config.HUNDREAD_PER_PAGE;
  const paginatedItems = filteredItems.slice(startIndex, endIndex);
  const totalPages = Math.ceil(filteredItems.length / config.HUNDREAD_PER_PAGE);

  const handleHabileAddClient = (item) => {
     const stopHabileLMSCall = true;
     if(stopHabileLMSCall){
      toast.error("Application is not using this functionality.", {
            position: "top-right",
        });
        return;
     } 

     // alert(`In progress , need to implement ${leadId}`);
     const leadId = item.id;
     const pan = item.pancard_number;

     const prefillTemplateNameId = item.prefill_template_name;
     console.log("Habile - item ",item);
     if (Object.prototype.hasOwnProperty.call(item, 'pan_details_decrypt')) { 
        setLegalFormId('person');
        const isSoleProp = item.pan_details_decrypt.isSoleProp;
        const isSalaried = item.pan_details_decrypt.isSalaried;
        const isDirector = item.pan_details_decrypt.isDirector;

        if (isDirector === true) {
           setLegalFormId('business');
        } 
        
     }else{
        toast.error("Lead pan details are missing.", {
            position: "top-right",
        });
        return;
     }
     
     if(!pan || pan.trim() ==='' || pan === null){
        toast.error("Pan Number is required.", {
            position: "top-right",
        });
      } else if(!prefillTemplateNameId || prefillTemplateNameId.trim() ==='' || prefillTemplateNameId === null) { 
        toast.error("Prefill Template is required.", {
            position: "top-right",
        });
      } else {
        const params = { 'lead_id': leadId, 'legalFormId':legalFormId, "prefillTemplateNameId":prefillTemplateNameId};
        const requestData = encryptData(params);
        const response = actions.addClientHabileInfo(requestData);
        response.then((result) => {
          console.log("habile message = ", result.data.message);
          if (result.data.success === 1) {
            console.log("habile response = ", result.data);

            if (Object.prototype.hasOwnProperty.call(result.data, 'habil_final_message') && result.data.habil_final_message !== '' && result.data.habil_final_message !== null) {
              toast.success(result.data.habil_final_message, {
                position: "top-right",
              });
            } else {
              toast.success(result.data.message, {
                position: "top-right",
              });
            }

          } else if (result.data.success === 0) {
            if (Object.prototype.hasOwnProperty.call(result.data, 'habil_final_message') && result.data.habil_final_message !== '' && result.data.habil_final_message !== null) {
              toast.error(result.data.habil_final_message, {
                position: "top-right",
              });
            } else {
              toast.error(result.data.message, {
                position: "top-right",
              });
            }
          } else {
            toast.error(result.data.habil_final_message, {
              position: "top-right",
            });
          }
        }).catch((error) => {
          // console.error("Promise rejected - add/edit lead form:", error);
          toast.error(error, {
            position: "top-right",
          });
        });
      }
       
      
      
  }

  const handleHabileAddIdentifier = (leadId,pan) => {
    // alert(`In progress , need to implement ${leadId}`);
    if(pan ===''){ 
     toast.error("Lead pan number is null.", {
         position: "top-right",
     });
     return;
   }
     const params = { 'lead_id': leadId};
      const requestData = encryptData(params);
      const response = actions.addIdentifierHabileInfo(requestData);
      response.then((result) => {
           if (result.data.success === 1) { 
              console.log("habile response = ", result.data.data); 
                   toast.success(result.data.message, {
                       position: "top-right",
                   }); 
          } else {
              toast.error(result.data.message, {
                  position: "top-right",
              });
          }
      }).catch((error) => {
          toast.error(error, {
              position: "top-right",
          });
      });
 }

  const checkLogout = () => {
    const authToken = localStorage.getItem('authToken');
    const logInTimestamp = localStorage.getItem('logInTimestamp');

    if (logInTimestamp !== null) {
      const loginTimestamp = parseInt(logInTimestamp, 10);
      const currentTime = Math.floor(Date.now() / 1000);
      const timeElapsed = currentTime - loginTimestamp;
      const autoLogoutTimeInSecod = config.AUTO_LOGOUT_TIME_IN_SECONDS;

      if (timeElapsed >= autoLogoutTimeInSecod) {
        const params = { 'login_token': authToken };
        console.log("params : ", params);
        const requestData = encryptData(params);
        const response = actions.userLogout(requestData);
        response.then((result) => {
          if (result.data.success === 1) {
            const data = {};
            actions.loadUserAuth(false);
            actions.loginDataSuccess(data);
            localStorage.setItem("authToken", '');
            localStorage.setItem("logInTimestamp", '');
            navigate("/login");
          }
        }).catch((error) => {
          console.log(error);
        });
      }
    }
  }

  useEffect(() => {
    checkLogout();
  });

  const clearfix = {
    clear: 'both'
  };
  const textAlignRight = {
    textAlign: 'right'
  };

  const [enachItem, setEnachItem] = useState([]);
  const [enachType, setEnachType] = useState('');
  const [proposedAmt, setProposedAmt] = useState('');
  const [proposedDebitDate, setProposedDebitDate] = useState('');
  const [openAmt, setOpenAmt] = useState(false);
  const [preloaderStatus, setPreloaderStatus] = useState(false);
  const [preloaderSearchStatus, setPreloaderSearchStatus] = useState(true);

  // UPI REGISTRATION START 
  // const [enchUPIitem, setEnachUPIitem] = useState([]);
  const [enchUPIitem, setEnachUPIitem] = useState({
    totalAmt: '',
    upiDebitDate: '',
  });
  
  const [openUPIAmt, setOpenUPIAmt] = useState(false);
  const [proposedUPIAmt, setproposedUPIAmt] = useState('');

  const btnOpenUPIData = (item) => {    // buttonFun
    setOpenUPIAmt(true);
    setEnachUPIitem(item);
    console.log("item Details 123", item);
  };

  const handleCloseUPIAmt = () => {     // Modal onclick closedFun
    setOpenUPIAmt(false);
    setEnachUPIitem([]);
  };

  const handleAmtUPIChange = (e) => {
    const totalAmt = e.target.value;
    setEnachUPIitem((prevState) => ({
      ...prevState,
      totalAmt,
    }));
  }

  const handleUPIDateChange = (e) => {
    const upiDebitDate = e.target.value;
    setEnachUPIitem((prevState) => ({
      ...prevState,
      upiDebitDate,
    }));
  }

  const handleUPIFormSubmit = (data) => { 
    console.log("ModalUPIHandle", data.emi_amount1);
  
    if (data.emi_amount1 === '') {
      toast.error("UPI Amount is required.", {
        position: "top-right",
      });
    } else if (data.debit_date1 === '') {
      toast.error("UPI Debit date is required.", {
        position: "top-right",
      });
    } else {
      enchUPIitem.totalAmt = data.emi_amount1;
      enchUPIitem.upiDebitDate = data.debit_date1;
      console.log("Updated enchUPIitem: ", enchUPIitem);
      onsendUPIRegistrationAction(enchUPIitem);
    }
  }
  
  const onsendUPIRegistrationAction = (item) => {  
    setPreloaderStatus(true); 
    
    // alert(item.emi_amount);
    const params = { 'lead_id': item.id, 'application_id': item.id,'brief' :'send_sms_to_user' ,'action' :'send_upi_link_to_user' ,'call_api_from' :'Lead', 'proposed_debit_date': item.upiDebitDate, 'proposed_amount': item.totalAmt, 'api_response': enchUPIitem,'enachType' : enachType};

    console.log("onsendUPIRegitrationDataShowParams", params);

    const requestData = encryptData(params);
    const response = actions.sendEnachUPIRegistrationDetails(requestData);
    response.then((result) => {
         
        if (result.data.success === 1) { 
            console.log("response = ", result.data.data); 
            setPreloaderStatus(false);
                 toast.success(result.data.message, {
                     position: "top-right",
                 });
                const obj = { 'start': '0', 'length': config.MAX_RECORDS, "user_role_type": userRoleType,
                  "is_cam_leads": isCamChecked };
                const requestData = encryptData(obj);
                setPreloaderSearchStatus(true);
                const response = actions.leadsData(requestData);
                response.then((result) => {
                  console.log("Promise resolved -  lead list:", result);
                  if (result.data.success === 1) {
                    setShowLeadDetails(true);
                    const results = result.data.data.data;
                    const resultArr = Object.keys(results).map((key) => results[key]);
                    setAllLeads(resultArr);
                  }
                  setPreloaderSearchStatus(false);
                }).catch((error) => {
                  console.error("Promise rejected -  lead list:", error);
                });   
            
        } else {
            setPreloaderStatus(false);
            toast.error(result.data.message, {
                position: "top-right",
            });
        }

        setOpenAmt(false); 
        setProposedAmt('');
        setProposedDebitDate('');
        setEnachItem([]); 
        setEnachType('');
    }).catch((error) => {
        setPreloaderStatus(false);
        toast.error(error, {
            position: "top-right",
        });
    });

 };  

  // UPI REGISTRATION END 

  const btnOpenUploadMissingData = (item,etype='') => {
    setOpenAmt(true);
    setEnachItem(item);
    setEnachType(etype);
    
  }

  const handleCloseAmt = () => {
    setOpenAmt(false); 
    // setProposedAmt('');
   // setProposedDebitDate('');
    setEnachItem([]); 
    setEnachType('');
  };


  const onSendEnachRegistrationAction = (item) => {  
    setPreloaderStatus(true); 
    
    // alert(item.emi_amount);
    const params = { 'lead_id': item.id, 'application_id': item.id,'brief' :'send_sms_to_user' ,'action' :'send_enach_link_to_user' ,'call_api_from' :'Lead','proposed_amount' : item.emi_amount,'proposed_debit_date' : item.debit_date,'enachType' : enachType};
    const requestData = encryptData(params);

     let response =  {};
    if(enachType ==='razorpay'){
        response = actions.sendRazorpayRegistrationDetails(requestData);
    } else {
        response = actions.sendEnachRegistrationDetails(requestData);
    }   

    response.then((result) => {
         
        if (result.data.success === 1) { 
            setPreloaderStatus(false);
                 toast.success(result.data.message, {
                     position: "top-right",
                 });

                // fetchHabileLoanApplicationsData(); 
                const obj = { 'start': '0', 'length': config.MAX_RECORDS, "user_role_type": userRoleType,
                  "is_cam_leads": isCamChecked };
                const requestData = encryptData(obj);
                setPreloaderSearchStatus(true);
                const response = actions.leadsData(requestData);
                response.then((result) => {
                  if (result.data.success === 1) {
                    setShowLeadDetails(true);
                    const results = result.data.data.data;
                    const resultArr = Object.keys(results).map((key) => results[key]);
                    setAllLeads(resultArr);
                  }
                  setPreloaderSearchStatus(false);
                }).catch((error) => {
                  console.error("Promise rejected -  lead list:", error);
                });   
            
        } else {
            setPreloaderStatus(false);
            toast.error(result.data.message, {
                position: "top-right",
            });
        }

        setOpenAmt(false); 
        setProposedAmt('');
        setProposedDebitDate('');
        setEnachItem([]);
        setEnachType('');
    }).catch((error) => {
        setPreloaderStatus(false);
        toast.error(error, {
            position: "top-right",
        });
    });

 };

 const handleFormSubmit = (data) => { 
    if(data.emi_amount ===''){
      toast.error("Amount is required.", {
        position: "top-right",
      }); 
   }else if(data.debit_date ===''){
      toast.error("Debit date is required.", {
        position: "top-right",
      });  
    }else{
      enachItem.emi_amount =  data.emi_amount;
      enachItem.debit_date =  data.debit_date;
      onSendEnachRegistrationAction(enachItem);
    }
   
 }

 const handleAmtChange = (e) => {
  const amt = e.target.value;
   setProposedAmt(amt);
};

const handleDebitDateChange = (e) => {
  const date = e.target.value;
   setProposedDebitDate(date);
};

const handleCamChange = (event) => { 
  setIsCamChecked(event.target.checked);
};

  if (!userHasPermission) {
    // Redirect or render an access denied message
    return <AccessDenied />;
  }
  return (
    <>
      <Helmet>
        <title> Leads | Ckers </title>
      </Helmet>

      <Container>
        <div className="d-flex align-items-center justify-content-between mb-0">
          <span>&nbsp;</span>
          <RouterLink to='/dashboard/create-lead' className='add-btn btn-primary btn'><i className="bi bi-plus">&nbsp;</i> Add Lead</RouterLink>

          <div className='form-group mb-2'> 
              <NavLink to={`/dashboard/enach-mandates`}>
              <button
                  type="button"
                  className="btn btn-primary text-white"
              >
                  cKers E-NACH Mandates
              </button>
              </NavLink>
              <span>&nbsp;</span>
          </div>

        </div>
        <div id='main-wrap' className='mb-3 mmt-7 filter'>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className='row mx-0'>
              <div className={isExternalUser ? "col d-none" : " col"}>
                <div className='form-group'>
                  <span>Assign To</span>
                  <div className="text-dark">
                    <Multiselect
                      id="assign_to"
                      options={allLoggedinUserChild.map((option) => ({
                        key: option.id,
                        value: option.name,
                      }))}
                      displayValue="value"
                      onSelect={(selectedItems) => {
                        const selectedValues = selectedItems.map(item => item.key);
                        setSelectedUsers(selectedValues);
                      }}
                      onRemove={(selectedItems) => {
                        const selectedValues = selectedItems.map(item => item.key);
                        setSelectedUsers(selectedValues);
                      }}
                    />
                  </div>
                </div> 
                 <div className={userRoleType.toLowerCase() === "credit head" ? "row" : " row d-none"} >
                    <div className='form-group'>
                        <label htmlFor="keyword">
                            <span title={userRoleType.toLowerCase()}>Approved Leads</span>
                            <input type='checkbox' name='is_cam_leads' id='is_cam_leads' {...register('is_cam_leads')} onChange={handleCamChange}
                            checked={isCamChecked}
                            />
                        </label>
                    </div>
                </div>


              </div>
              <div className='col'>
                <div className='form-group'>
                  <label htmlFor="start-date">
                    <span>Start Date</span>
                    <input type='date' name='start_date' 
                    className='form-control'
                    {...register('start_date')} />
                  </label>

                </div>
              </div>

              <div className='col'>
                <div className='form-group'>
                  <label htmlFor="end-date">
                    <span>End Date</span>
                    <input type='date' name='end_date' 
                    className='form-control'
                    {...register('end_date')} />
                  </label>

                </div>
              </div>
              <div className={isExternalUser ? "col d-none" : " col"}>
                <div className='form-group'>
                  <span>Lead Source</span>
                  <div className="text-dark">
                    <Multiselect
                      id="lead_profile"
                      options={allLeadSource.map((option) => ({
                        key: option.id,
                        value: option.name,
                      }))}
                      displayValue="value"
                      onSelect={(selectedItems) => {
                        const selectedValues = selectedItems.map(item => item.key);
                        setSelectedLeadSource(selectedValues);
                      }}
                      onRemove={(selectedItems) => {
                        const selectedValues = selectedItems.map(item => item.key);
                        setSelectedLeadSource(selectedValues);
                      }}
                    />
                  </div>
                </div>
              </div>
              <div className='col'>
                <div className='form-group'>
                  <span>Lead Status</span>
                  <div className="text-dark">
                    <Multiselect
                      id="lead_profile"
                      options={allLeadStatusData.map((option) => ({
                        key: option.id,
                        value: option.name,
                      }))}
                      displayValue="value"
                      onSelect={(selectedItems) => {
                        const selectedValues = selectedItems.map(item => item.key);
                        setSelectedLeadStatus(selectedValues);
                      }}
                      onRemove={(selectedItems) => {
                        const selectedValues = selectedItems.map(item => item.key);
                        setSelectedLeadStatus(selectedValues);
                      }}
                    />
                  </div>
                </div>
              </div>
              <div className={isExternalUser ? "col d-none" : " col"}>
                <div className='form-group'>
                  <span>Lead Profile</span>
                  <div className="text-dark">
                    <Multiselect
                      id="lead_profile"
                      options={allMasterProfiles.map((option) => ({
                        key: option.id,
                        value: option.name,
                      }))}
                      displayValue="value"
                      onSelect={(selectedItems) => {
                        const selectedValues = selectedItems.map(item => item.key);
                        setSelectedLeadProfile(selectedValues);
                      }}
                      onRemove={(selectedItems) => {
                        const selectedValues = selectedItems.map(item => item.key);
                        setSelectedLeadProfile(selectedValues);
                      }}
                    />
                  </div>
                </div>
              </div>


              <div className='col'>
                    <div className='form-group'>
                        <label htmlFor="reporting-user">
                            <span>Track Type</span>
                            <select name='fast_track_status' className="form-select" {...register('fast_track_status')}>
                            <option value="">All</option>
                            <option value="fast">Fast Track</option>
                            <option value="normal">Normal Track</option>
                            <option value="green_channel">Green Channel</option>
                            <option value="green_fast">Green Channel + Fast Track</option>
                            </select>
                        </label>
                     </div>
                </div>

           {/* mark for api logic */}
              <div className='col'>
              <div className='form-group'>
                <label htmlFor="action_status">
                  <span>Cam  Status</span>
                  <select
                    name='action_status'
                    className="form-select"
                    {...register('action_status')}
                  >
                    <option value="">All</option>
                    <option value="0">Send For Approval</option>
                    <option value="1">Approved</option>
                    <option value="2">Rejected</option>
                    <option value="3">Reversal Request</option>
                  </select>
                </label>
              </div>
            </div>

            <div className='col'>
              <div className='form-group'>
                <label htmlFor="state">
                  <span>State</span>

                  <select
                    name="state"
                    className="form-select"
                    {...register('state')}
                  >
                    <option value="">All States</option>

                   {states.map((item) => {
                      return (
                        <option key={item.id} value={item.state_code}>
                          {item.name}
                        </option>
                      );
                    })}

                  </select>
                </label>
              </div>
            </div>

              <div className='col'>
                <div className='form-group'>
                  <label htmlFor="keyword">
                    <span>Keyword</span>
                    <input type='text' name='keyword' id='keyword' className='form-control'{...register('keyword')} placeholder="Lead name, email or mobile" />
                  </label>
                </div>
              </div>

              <div className='col'>
                <div className='form-group mb-2'>
                  <span className='d-block'>&nbsp;</span>
                  <button className='btn btn-primary'>Search</button>

                   {preloaderSearchStatus && (<>
                    <div className="spinner-border small-preloader" role="status" >
                        &nbsp;
                    </div>  </>)}
                </div>
              </div>

            </div>
          </form>
        </div>

        <div id='main-wrap' className='mb-4'>
          <div className='row justify-content-between'>
            <div className='col-md-8'> 
              <Typography className='line-initial' variant="h4" sx={{ mb: 0 }}>
                All Leads
              </Typography>
            </div>
            <div className='col-md-4 pe-0 ps-lg-5'>
              <div className="form-group">
                 
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search Status, Name, Created by.. "
                    id="search"
                    value={searchQuery}
                    onChange={handleSearchChange}
                  />
                 
              </div>
            </div>
          </div>
          <div className='table-wrap'>
            <table className="table table-hover">
              <thead>
                <tr>
                  <th className='text-nowrap'>S. No.</th>
                  <th>Name</th>
                  <th>Assign To</th>
                  <th>Mobile</th>
                  <th>Lead Assign To</th>
                  {!isExternalUser && ( <> <th>Created by</th> </>)}
                  <th>Created Date</th>
                  <th>Track Type</th>
                  <th>Status</th>
                  {userRoleType.toLowerCase() === "credit head"  &&(
                    <th>CAM Status</th>
                  )} 
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {paginatedItems.map((item, index) => {

                let ENachSentStatus =  false;
                let ENachUserStatus =  false;
                let ENachUserHtml = '';  
                let isFleetId = false; 

                if(item?.is_fleet){
                    isFleetId = true; 
                }
                if ( item.EnachDetails &&   Object.prototype.hasOwnProperty.call(item.EnachDetails, 'id')
                ) {
                    ENachSentStatus =  true;
 
                    if ( Object.prototype.hasOwnProperty.call(item.EnachDetails, 'userEnachResponse') && Object.prototype.hasOwnProperty.call(item.EnachDetails.userEnachResponse, 'response_status')
                    ) {
                        if (item.EnachDetails.userEnachResponse.response_status === 'Success') {
                          ENachUserHtml = `<div>cKers E-NACH process successfully done.</div>`;
                              ENachUserStatus = true;
                           
                        }else{ 
                          ENachUserHtml = `<div>cKers E-NACH process ${item.EnachDetails.userEnachResponse.response_status}.</div>`;

                        }
                    }
                    
                }


                let RazorpayENachSentStatus =  false;
                let RazorpayENachUserStatus =  false;
                let RazorpayENachUserHtml = '';  
                if ( item.RazorpayEnachDetails &&   Object.prototype.hasOwnProperty.call(item.RazorpayEnachDetails, 'id')
                ) {
                     RazorpayENachSentStatus = true;

                    if ( Object.prototype.hasOwnProperty.call(item.RazorpayEnachDetails, 'userEnachResponse') && Object.prototype.hasOwnProperty.call(item.RazorpayEnachDetails.userEnachResponse, 'response_status')
                    ) {
                        if (item.RazorpayEnachDetails.userEnachResponse.response_status === 'Success') {
                          RazorpayENachUserHtml = `<div>Vivriti E-NACH process successfully done.</div>`;
                          RazorpayENachUserStatus = true;
                        }else{ 
                          RazorpayENachUserHtml = `<div>Vivriti E-NACH process ${item.RazorpayEnachDetails.userEnachResponse.response_status}.</div>`;

                        }
                    }
                    
                }

                


                let UPISentStatus =  false;
                let UPIUserStatus =  false;
                let UPIUserHtml = '';  
                if ( item.UPIDetails &&   Object.prototype.hasOwnProperty.call(item.UPIDetails, 'id')
                ) {
                    UPISentStatus =  true;

                    if ( Object.prototype.hasOwnProperty.call(item.UPIDetails, 'userUPIResponse') && Object.prototype.hasOwnProperty.call(item.UPIDetails.userUPIResponse, 'response_status')
                    ) {
                        if (item.UPIDetails.userUPIResponse.response_status === 'Success') {
                          UPIUserHtml = `<div>UPI process successfully done.</div>`;
                          UPIUserStatus = true;
                        }else{ 
                          UPIUserHtml = `<div>UPI process ${item.UPIDetails.userUPIResponse.response_status}.</div>`;

                        }
                    }
                    
                }

                const safeCurrentPage = Number.isInteger(currentPage) ? currentPage : 1;
                const safeItemsPerPage = Number.isInteger(config.HUNDREAD_PER_PAGE) ? config.HUNDREAD_PER_PAGE : paginatedItems.length;
                const rowIndex = (safeCurrentPage - 1) * safeItemsPerPage + index + 1;
              return (   
                <>  
                  <tr key={index}  style={{ background: ( item.AgreementNo === '' &&  item.green_channel_status === '1' && item.fast_track_status === '1' ) ? "rgb(253 255 117)" : ((item.AgreementNo === '' &&  item.green_channel_status === '1' ) ? "#caf3cb" : ((item.AgreementNo === '' && item.fast_track_status === '1' ) ? "rgb(196 245 250)" : "#ffffff"))  }}>
                    <td style={{ background: (item.AgreementNo === '' &&  item.green_channel_status === '1' && item.fast_track_status === '1' ) ? "rgb(253 255 117)" : ((item.AgreementNo === '' &&  item.green_channel_status === '1' ) ? "#caf3cb" : (( item.AgreementNo === '' && item.fast_track_status === '1' ) ? "rgb(196 245 250)" : "#ffffff"))  }}>{rowIndex} </td>
                    <td style={{ background: (item.AgreementNo === '' &&  item.green_channel_status === '1' && item.fast_track_status === '1' ) ? "rgb(253 255 117)" : ((item.AgreementNo === '' &&  item.green_channel_status === '1' ) ? "#caf3cb" : (( item.AgreementNo === '' &&  item.fast_track_status === '1' ) ? "rgb(196 245 250)" : "#ffffff"))  }}>{item.name}</td>
                    <td style={{ background: (item.AgreementNo === '' &&  item.green_channel_status === '1' && item.fast_track_status === '1' ) ? "rgb(253 255 117)" : ((item.AgreementNo === '' &&  item.green_channel_status === '1' ) ? "#caf3cb" : (( item.AgreementNo === '' && item.fast_track_status === '1' ) ? "rgb(196 245 250)" : "#ffffff"))  }}>{item.reporting_user_names}</td>
                    <td style={{ background: (item.AgreementNo === '' &&  item.green_channel_status === '1' && item.fast_track_status === '1' ) ? "rgb(253 255 117)" : ((item.AgreementNo === '' &&  item.green_channel_status === '1' ) ? "#caf3cb" : (( item.AgreementNo === '' && item.fast_track_status === '1' ) ? "rgb(196 245 250)" : "#ffffff"))  }}>{item.mobile}</td>
                    <td style={{ background: (item.AgreementNo === '' &&  item.green_channel_status === '1' && item.fast_track_status === '1' ) ? "rgb(253 255 117)" : ((item.AgreementNo === '' &&  item.green_channel_status === '1' ) ? "#caf3cb" : ((item.AgreementNo === '' &&  item.fast_track_status === '1' ) ? "rgb(196 245 250)" : "#ffffff"))  }}>{item.reporting_user_names}</td>
                    {!isExternalUser && ( <> <td style={{ background: (item.AgreementNo === '' &&  item.green_channel_status === '1' && item.fast_track_status === '1' ) ? "rgb(253 255 117)" : ((item.AgreementNo === '' &&  item.green_channel_status === '1' ) ? "#caf3cb" : ((  item.AgreementNo === '' && item.fast_track_status === '1' ) ? "rgb(196 245 250)" : "#ffffff"))  }}>{item.createdByName}</td> </>)}
                    <td style={{ background: (item.AgreementNo === '' &&  item.green_channel_status === '1' && item.fast_track_status === '1' ) ? "rgb(253 255 117)" : ((item.AgreementNo === '' &&  item.green_channel_status === '1' ) ? "#caf3cb" : (( item.AgreementNo === '' && item.fast_track_status === '1' ) ? "rgb(196 245 250)" : "#ffffff"))  }}>{item.created_date}</td>

                    <td style={{ background: (item.AgreementNo === '' &&  item.green_channel_status === '1' && item.fast_track_status === '1' ) ? "rgb(253 255 117)" : ((item.AgreementNo === '' &&  item.green_channel_status === '1' ) ? "#caf3cb" : (( item.AgreementNo === '' && item.fast_track_status === '1' ) ? "rgb(196 245 250)" : "#ffffff"))  }}>
                      
                      { (item.fast_track_status === '1' && item.green_channel_status === '1') ? "Fast + Green Channel": ((item.fast_track_status === '1' ) ? "Fast": ((item.green_channel_status === '1') ? "Green Channel": 'Normal'))}
                      
                      <div className="mt-1 d-flex flex-wrap gap-1">
                        {getEnabledLeadFlags(item).map(flag => (
                          <span key={flag.key} className="badge text-bg-info text-white success-blink" title={flag.key}>
                            {flag.label}
                          </span>
                        ))}
                      </div></td>

                    <td style={{ background: (item.AgreementNo === '' &&  item.green_channel_status === '1' && item.fast_track_status === '1' ) ? "rgb(253 255 117)" : ((item.AgreementNo === '' &&  item.green_channel_status === '1' ) ? "#caf3cb" : (( item.AgreementNo === '' && item.fast_track_status === '1' ) ? "rgb(196 245 250)" : "#ffffff"))  }}><span
                      className={(item.status === '1') ? "badge text-bg-success text-white" : (item.status === '2') ? "badge text-bg-warning text-white" : "badge text-bg-danger text-white"}
                    >{item.statusName === "CALL" ? 'No Interaction' : item.statusName}</span>
                    
                    {userRoleType.toLowerCase() !== "credit head" && item.camLatestStatusMsg!=='' && (
                      <>
                      <span
                      className={(item.camLatestStatus === '1') ? "badge text-bg-success text-white success-blink" : (item.camLatestStatus === '2') ? "badge text-bg-warning text-white success-blink" : "badge text-bg-danger text-white success-blink"}
                    >{item.camLatestStatusMsg}</span>
                      </>
                    )}
                    </td>

                    {userRoleType.toLowerCase() === "credit head"  &&(
                       <> <td style={{ background: (item.AgreementNo === '' &&  item.green_channel_status === '1' && item.fast_track_status === '1' ) ? "rgb(253 255 117)" : ((item.AgreementNo === '' &&  item.green_channel_status === '1' ) ? "#caf3cb" : (( item.AgreementNo === '' &&  item.fast_track_status === '1' ) ? "rgb(196 245 250)" : "#ffffff"))  }}>
                        {item.camLatestStatusMsg!=='' && (
                          <>
                          
                          <span
                          className={(item.camLatestStatus === '1') ? "badge text-bg-success text-white " : (item.camLatestStatus === '2') ? "badge text-bg-warning text-white" : "badge text-bg-danger text-white "}
                        >{item.camLatestStatusMsg}</span>
                          </>
                        )}
                        </td>
                       </>
                    )}

                    <td style={{ background: (item.AgreementNo === '' &&  item.green_channel_status === '1' && item.fast_track_status === '1' ) ? "rgb(253 255 117)" : ((item.AgreementNo === '' &&  item.green_channel_status === '1' ) ? "#caf3cb" : (( item.AgreementNo === '' && item.fast_track_status === '1' ) ? "rgb(196 245 250)" : "#ffffff"))  }}>
                        <div className="btn-group dropstart" title="Edit">
                            <NavLink to={`/dashboard/edit-lead-v3/${btoa(String(item.id))}`}><i className="bi bi-pen" style={{color: "black"}}/></NavLink>
 
                        </div> 
                    {!isExternalUser && ( <>                        

                       {(item.statusName === 'Ok to Proceed' || item.is_ok_to_proceed === "1") && ( 
                        <>  

                        {/*    <button 
                            type="button"
                            className={(item.habile_lms === 1) ? "d-none badge text-bg-success text-white float-right" : "badge text-bg-success text-white float-right d-none"}
                            onClick={() => handleHabileAddClient(item)}
                            > 
                           Habile - LMS
                        </button>

                       UPI Registration Start */}


                        { (viewUPIModulePermissionStatus) && (
                          <>
                        <button style={{margin: '0.2rem 0rem'}}
                            type="button"
                            className={(UPIUserStatus) ? "d-none badge btn btn-primary text-white float-right" : "badge btn btn-primary text-white float-right"}
                             onClick={(e) => {
                              e.preventDefault();
                             /* onSendEnachRegistrationAction(item) */
                              btnOpenUPIData(item)}
                              }
                            > 
                            {preloaderStatus && (<>
                              <div className="spinner-border small-preloader d-none" role="status" >
                                  <span className="visually-hidden">Loading...</span>
                              </div></>)}
                           UPI REGISTRATION
                        </button>
                        </>
                        )}
                         

                        {/* UPI Registration End */}
                        
                        {( isFleetId ? (<>
                                   <button type="button" className={(ENachUserStatus) ? "d-none- badge btn btn-success text-white float-right" : "badge btn btn-success text-white float-right"}
                                      onClick={(e) => {e.preventDefault(); /* onSendEnachRegistrationAction(item) */
                                        btnOpenUploadMissingData(item)}}> 
                                      {preloaderStatus && (<>
                                        <div className="spinner-border small-preloader d-none" role="status" >
                                            <span className="visually-hidden">Loading...</span>
                                        </div></>)}
                                    cKers E-NACH Registration For Fleet
                                  </button>
                            </>) : (<>
                                   <button type="button" className={(ENachUserStatus) ? "d-none badge btn btn-success text-white float-right" : "badge btn btn-success text-white float-right"}
                                      onClick={(e) => {e.preventDefault(); /* onSendEnachRegistrationAction(item) */
                                        btnOpenUploadMissingData(item)}}> 
                                      {preloaderStatus && (<>
                                        <div className="spinner-border small-preloader d-none" role="status" >
                                            <span className="visually-hidden">Loading...</span>
                                        </div></>)}
                                    cKers E-NACH Registration
                                  </button>
                            </>)
                      )}
                       

                      {/* Razorpay Registration Start */}
                         <button type="button" className={(RazorpayENachUserStatus) ? "d-none badge btn btn-warning text-white float-right" : "badge btn btn-warning text-white float-right"}
                             onClick={(e) => {e.preventDefault(); /* onSendEnachRegistrationAction(item) */
                              btnOpenUploadMissingData(item,'razorpay')}}> 
                            {preloaderStatus && (<>
                              <div className="spinner-border small-preloader d-none" role="status" >
                                  <span className="visually-hidden">Loading...</span>
                              </div></>)}
                           Vivriti E-NACH Registration
                        </button>
                         {/* Razorpay Registration End */}       
                        </>
                       )}

                       

                        <div className={(item.habile_lms === 0) ? "d-none float-right" : "float-right"}>
                          Sent to Habile <span className={(item.sentToHabileLmsDate === '') ? "d-none" : ""}>on {item.sentToHabileLmsDate}</span>
                          <span className={(item.sentToHabileLmsByUser === '') ? "d-none" : ""}>&nbsp;By {item.sentToHabileLmsByUser}</span>
                        </div>

                        {(ENachSentStatus) && (
                          <>
                          
                          <div style={clearfix} className="text-success align-right">cKers E-NACH link sent to #{item.mobile}</div>
                          <div style={clearfix} className={(ENachUserStatus) ? "text-success align-right" : "text-danger align-right"} dangerouslySetInnerHTML={{ __html: ENachUserHtml.replace(/\n/g, '<br />') }} />

                           { isFleetId && (item.EnachDetails?.userEnachResponse?.addedSuccessRecordsForFleet || []).length > 0 && (
                             <>
                               &nbsp;
                               <span
                                 role="button"
                                 tabIndex={0}
                                 className="text-primary text-decoration-underline float-right"
                                 style={{ cursor: 'pointer' }}
                                 onClick={(e) => {
                                   e.preventDefault();
                                   handleViewFleetRecords(item.EnachDetails?.userEnachResponse?.addedSuccessRecordsForFleet);
                                 }}
                                 onKeyDown={(e) => {
                                   if (e.key === 'Enter' || e.key === ' ') {
                                     e.preventDefault();
                                     handleViewFleetRecords(item.EnachDetails?.userEnachResponse?.addedSuccessRecordsForFleet);
                                   }
                                 }}
                               >
                                 View E-NACH Details
                               </span>
                             </>
                           )}
                          </> )}

                           {(RazorpayENachSentStatus) && (
                          <>
                          
                          <div style={clearfix} className="text-success align-right">Vivriti E-NACH link sent to #{item.mobile}</div>
                          <div style={clearfix} className={(RazorpayENachUserStatus) ? "text-success align-right" : "text-danger align-right"} dangerouslySetInnerHTML={{ __html: RazorpayENachUserHtml.replace(/\n/g, '<br />') }} />

                          </> )}

                          {(UPISentStatus) && (
                          <>
                          
                          <div style={clearfix} className="text-success align-right">UPI link sent to #{item.mobile}</div>
                          <div style={clearfix} className={(UPIUserStatus) ? "text-primary align-right" : "text-danger align-right"} dangerouslySetInnerHTML={{ __html: UPIUserHtml.replace(/\n/g, '<br />') }} />

                          </> )}
                      </>)}

                      {/*  <NavLink className={(item.habile_lms === 0) ? "d-none float-right" : "float-right"} to={`/dashboard/send-to-allcloud/${btoa(String(item.id))}`}>                          
                        <button 
                            type="button"
                            className= "badge text-bg-warning text-white float-right"
                            > 
                           Send To AllCloud
                        </button></NavLink> */}
                    </td>                    
                  </tr>

                  </>);
                
              })}

                { paginatedItems.length < 1 && (
                    <>
                      <tr>
                        <td colSpan={10} className='text-center py-3 fw-bold'>
                           {preloaderSearchStatus ? (<>
                            &nbsp; &nbsp;<span>Loading...</span>  <div className="spinner-border small-preloader" role="status" >
                               &nbsp;
                            </div>  </>) : (
                             <>
                              <span>No records found.</span>
                             </>
                            )}
                        </td>
                      </tr>
                    </>
                )}
              </tbody>
            </table>
          </div>
          <div>
          <nav className='mb-1'>
            <ul className="pagination pagination-md justify-content-end">
              {Array.from({ length: totalPages }, (_, index) => index + 1).map(page => (
                <li className="page-item">
                  <button
                    key={page}
                    onClick={() => handlePageChange(page)}
                    disabled={currentPage === page}
                    className="page-link"
                  >
                    {page}
                  </button>
                </li>
              ))}
            </ul>
          </nav>
          </div>
        </div>
      </Container>

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
      >
        <div className='modal-custom rounded'>
          <div className='modal-head'>
            <h4 id="modal-title">Lead  : {viewModalInfo.name}</h4>
            <Button onClick={handleClose} color="primary" className=' btn'>
              <i className="bi bi-x">&nbsp;</i>
            </Button>
          </div>
          <div className='modal-body'>
            <div className='row mb-2 pb-1'>
              <div className='col-4'><b>Lead ID :</b></div>
              <div className='col-7 ps-0'>{viewModalInfo.id}</div>
            </div>

            <div className='row mb-2 pb-1'>
              <div className='col-4'><b>Created By :</b></div>
              <div className='col-7 ps-0'>{viewModalInfo.lead_created_by}</div>
            </div>

            <div className='row mb-2 pb-1'>
              <div className='col-4'><b>Lead Status :</b></div>
              <div className='col-7 ps-0'><span className={(viewModalInfo.status === '1') ? "badge text-bg-success text-white" : (viewModalInfo.status === '2') ? "badge text-bg-warning text-white" : "badge text-bg-danger text-white"}>{viewModalInfo.statusName}</span></div>
            </div>
          </div>
        </div>
      </Modal>


      <Modal
                open={openAmt}
                onClose={handleCloseAmt}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <div className='modal-custom rounded'>
                    <div className='modal-head'>
                        <h4 id="modal-title">What is the proposed EMI amount?</h4>
                        <Button onClick={handleCloseAmt} color="primary" className=' btn'>
                            <i className="bi bi-x">&nbsp;</i>
                        </Button>
                    </div>
                    
                    <div className='modal-body'>
                        <div>
                            <form onSubmit={handleSubmit(handleFormSubmit)} encType="multipart/form-data">
                                <div className="row mx-0">
                                    <div className="col-md-6 px-0">
                                        <div className="form-group">
                                            <label htmlFor="itr_file">
                                                <span>EMI Amount <a style={{ color: "red" }}>*</a></span>
                                                <input type='number' id='emi_amount' name='emi_amount'
                                                    className='form-control' {...register('emi_amount')}
                                                    onChange={handleAmtChange}/>
                                            </label>
                                        </div>
                                    </div>

                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label htmlFor="itr_file">
                                                <span>Debit Date <a style={{ color: "red" }}>*</a></span>
                                                <input type='date' id='debit_date' name='debit_date'
                                                    className='form-control' {...register('debit_date')}
                                                    onChange={handleDebitDateChange}/>
                                            </label>
                                        </div>
                                    </div>

                                    <div className="col-md-12 px-0">
                                        <div className="form-group mb-0">
                                            <button className="btn btn-primary mt-2">
                                                Submit
                                            </button>
                                        </div>
                                    </div>

                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </Modal>

        {/* UPI REGISTRATION MODAL START */}
            <Modal open={openUPIAmt} onClose={handleCloseUPIAmt} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
            <div className='modal-custom rounded'>
              <div className='modal-head'>
                <h4 id="modal-title">UPI Amount </h4>
                <Button onClick={handleCloseUPIAmt} color="primary" className='btn'>
                  <i className="bi bi-x"> &nbsp;</i>
                </Button>
              </div>

              <div className='modal-body'>
                <form onSubmit={handleSubmit(handleUPIFormSubmit)} encType="multipart/form-data">
                  <div className="row mx-0">
                    
                    <div className="col-md-6">
                      <div className="form-group">
                        <label htmlFor="itr_file">
                          <span>UPI Amount <a style={{ color: "red" }}>*</a></span>
                          <input type='number' id='emi_amount1' name='emi_amount1' className='form-control'
                            {...register('emi_amount1')} onChange={handleAmtUPIChange}/>
                        </label>
                      </div>
                    </div>

                <div className="col-md-6">
                  <div className="form-group">
                    <label htmlFor="itr_file">
                      <span>Debit Date <a style={{ color: "red" }}>*</a></span>
                      <input type='date' id='upi_debit_date1' name='debit_date1' className='form-control' {...register('debit_date1')} onChange={handleUPIDateChange} />
                    </label>
                  </div>
                </div>

                    <div className="col-md-12">
                      <div className="form-group mb-0">
                        <button className="btn btn-primary mt-2">
                          UPI REGISTRATION NOW
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </Modal>
        {/* UPI REGISTRATION MODAL END */}

        {/* FLEET SUCCESS RECORDS MODAL START */}
        <Modal
          open={openFleetModal}
          onClose={handleCloseFleetModal}
          aria-labelledby="fleet-modal-title"
          aria-describedby="fleet-modal-description"
        >
          <div className='modal-custom rounded'>
            <div className='modal-head'>
              <h4 id="fleet-modal-title">Fleet E-NACH Success Records</h4>
              <Button onClick={handleCloseFleetModal} color="primary" className='btn'>
                <i className="bi bi-x">&nbsp;</i>
              </Button>
            </div>

            <div className='modal-body' style={{ maxHeight: '400px', overflowY: 'auto' }}>
              {fleetRecordsInfo && fleetRecordsInfo.length > 0 ? (
                <div className="table-responsive">
                  <table className="table table-bordered table-sm">
                    <thead>
                      <tr>
                        <th>#</th>
                        {Object.keys(fleetRecordsInfo[0]).map((key) => (
                          <th key={key}>{key}</th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {fleetRecordsInfo.map((record, idx) => (
                        <tr key={idx}>
                          <td>{idx + 1}</td>
                          {Object.keys(fleetRecordsInfo[0]).map((key) => (
                            <td key={key}>{record[key] !== null && record[key] !== undefined ? String(record[key]) : ''}</td>
                          ))}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              ) : (
                <span>No fleet records found.</span>
              )}
            </div>
          </div>
        </Modal>
        {/* FLEET SUCCESS RECORDS MODAL END */}

    </>
  );
}

function mapStateToProps(state) {
  return {
    leadsData: state.leadsData,
    usersData: state.usersData,
    sourceData: state.sourceData,
    getUserModuleData: state.getUserModuleData,
    masterProfileData: state.masterProfileData,
    leadStatusData: state.leadStatusData,
    getLoggedinUserChild: state.getLoggedinUserChild,
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(Object.assign(leadActions.default, userActions.default, incidentReporteActions.default), dispatch),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(LeadsPage2);